import React, {Fragment} from 'react';
import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import AddIcon from "@mui/icons-material/Add";
import Fab from "@mui/material/Fab";
import Alert from "@mui/material/Alert";
import {useCollection} from "react-firebase-hooks/firestore";
import {collection} from "firebase/firestore";

import StaffTable from "../../components/dashboard/StaffTable";
import StaffModalForm from "../../components/dashboard/StaffModalForm";
import AxiosApi from "../../config/axiosApi";
import {getFirebase} from "../../config/firebase.config";
import Loading from "../../components/common/Loading";
import Title from "../../components/common/Title";
import {getAuthToken} from "../../lib/helpers";

const DashboardStaff = () => {
    const {firestore, auth} = getFirebase();
    const [showModal, setShowModal] = React.useState(false);
    const [value, loading, error] = useCollection(collection(firestore, 'staff'));
    const handleCloseModal = (event) => {
        event.preventDefault();
        setShowModal(false)
    }

    const removeStaff = async (email) => {
        const url = "/account/removeAdminRole";
        try {
            AxiosApi.defaults.headers.common["Authorization"] = "Bearer " + await getAuthToken();
            let response = await AxiosApi.post(url, {email});
            console.log(response.data);
        } catch (e) {
            console.log(e);
        }
    }
    if (loading) {
        return <Loading/>
    }

    return (
        <Fragment>
            <StaffModalForm
                open={showModal}
                handleClose={handleCloseModal}
            />
            <Box sx={{'& > :not(style)': {m: 1, position: 'absolute', bottom: '10%', right: '4%'}}}>
                <Fab color="primary" aria-label="add" onClick={(e) => setShowModal(true)}>
                    <AddIcon/>
                </Fab>
            </Box>
            {error && <Alert severity="error">{error.message}</Alert>}
            <Container maxWidth="xl" sx={{mt: 4, mb: 4}}>
                <Grid container spacing={1}>
                    <Grid item xs={12}>
                        {value.empty && <Title>No staff yet!</Title>}
                        {!value.empty && <StaffTable data={value.docs} removeStaff={removeStaff}/>}
                    </Grid>
                </Grid>
            </Container>
        </Fragment>
    );
};

export default DashboardStaff;